export const DEFAULT_OPPORTUNITY_IMAGE = '/default.svg'

export const OPPORTUNITY_LIST_PAGE_SIZE = 10
